import { render, staticRenderFns } from "./TabBarItem.vue?vue&type=template&id=4d456288&scoped=true&"
import script from "./TabBarItem.vue?vue&type=script&lang=js&"
export * from "./TabBarItem.vue?vue&type=script&lang=js&"
import style0 from "./TabBarItem.vue?vue&type=style&index=0&id=4d456288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d456288",
  null
  
)

export default component.exports